import Page from './Page';
export default Page;
export * from './Page.actions';
export * from './Page.functions';
